import { keepPreviousData } from '@tanstack/react-query';

import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getAccountTeams, type TeamsListParams, type TeamsListResponse } from '../api';
import type { Account } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useTeams(account: Account, params: TeamsListParams) {
  return useAccountQuery<TeamsListResponse, RequestError>(
    queryKeys.accounts.teams(account._id, params),
    ({ signal }) => observableToPromise(getAccountTeams(account, params), signal),
    account,
    { placeholderData: keepPreviousData },
  );
}
